<template>
	<div class="vue-example">
<!--		<div class="vue-example__container container">-->
<!--			<BlockCount :title="title" :count="count" :inc="inc"/>-->
<!--			<BlockList :title="subtitle" :pages="pages"/>-->
<!--		</div>-->
		<BlockEventDropdown />
		<BlockSearchBox />
		<BlockEventSearchBoxDropdown />
		<BlockCategoryDropdown />
		<BlockItemListing />
		<BlockCategorySearchBoxDropdown />
		<BlockProductListing />
		<BlockFilter />
	</div>
</template>

<script>
	import BlockSearchBox from './blocks/BlockSearchBox.vue';
	import BlockEventDropdown from './blocks/BlockEventDropdown.vue';
	import BlockEventSearchBoxDropdown from './blocks/BlockEventSearchBoxDropdown.vue';
	import BlockCategoryDropdown from './blocks/BlockCategoryDropdown.vue';
	import BlockCategorySearchBoxDropdown from './blocks/BlockCategorySearchBoxDropdown.vue';
	import BlockItemListing from './blocks/BlockItemListing.vue';
	import BlockProductListing from './blocks/BlockProductListing.vue';
	import BlockFilter from './blocks/BlockFilter.vue';

	export default {
		beforeMount() {
			this.$store.dispatch('setPages');
		},

		data() {
			return {
				subtitle: 'This is subtitle'
			};
		},

		components: {
			// BlockCount,
			// BlockList,
			BlockItemListing,
			BlockSearchBox,
			BlockEventDropdown,
			BlockCategorySearchBoxDropdown,
			BlockEventSearchBoxDropdown,
			BlockCategoryDropdown,
			BlockProductListing,
			BlockFilter
		},

		computed: {
			title() {
				return this.$store.getters.getTitle;
			},
			count() {
				return this.$store.getters.getCount;
			},
			pages() {
				return this.$store.getters.getPages;
			}
		},

		methods: {
			inc() {
				this.$store.commit('increment');
			}
		}
	};
</script>

<style lang="scss" scoped>
	.vue-example {
		padding: 50px 0;
	}

	.vue-example__container {
		border-width: 1px 0 1px 0;
		border-color: rgba($black, .3);
		border-style: solid;
		padding-top: 50px;
		padding-bottom: 50px;
	}
</style>
